import script from "./SubareaGuide.vue?vue&type=script&setup=true&lang=js"
export * from "./SubareaGuide.vue?vue&type=script&setup=true&lang=js"

import "./SubareaGuide.vue?vue&type=style&index=0&id=36bf81e5&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-36bf81e5"]])

export default __exports__